import { request } from "../utils/request.js"

export const fundAccount_findUnfrozenList = ( args) => request({
    url: 'fundAccount/findUnfrozenList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const fundAccount_addNew = (pojo, args) => request({
    url: 'fundAccount/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_update = (pojo, args) => request({
    url: 'fundAccount/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_findPageForManage = (pojo, args) => request({
    url: 'fundAccount/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_findPageForSelect = (pojo, args) => request({
    url: 'fundAccount/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_findListForManage = (pojo, args) => request({
    url: 'fundAccount/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_findListForSelect = (pojo, args) => request({
    url: 'fundAccount/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_changeFrozenStatus = (id, args) => request({
    url: 'fundAccount/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_findById = (id, args) => request({
    url: 'fundAccount/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const fundAccount_changeDefaultMark = (id, args) => request({
    url: 'fundAccount/changeDefaultMark',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_getDefault = (args) => request({
    url: 'fundAccount/getDefault',
    method: 'GET',
    showFailMessage: false,
    showSuccessMessage: false,
    ...args
})


export const fundAccount_deleteById = (id, args) => request({
    url: 'fundAccount/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/fundAccount.js